import { DataService } from "@/services/data";
import { LMSDataService } from "@/services/lms_data";
import { ProductSessionSeatsType } from "@/types/content/product_session";
import { LMSProduct } from "@/types/lms/training/product";
import { handle_error, handle_success } from "@/utils/wretch";
import { RouteObject } from "react-router-dom";

const LMSRoute: RouteObject = {
    path: "lms",
    children: [
        {
            id: "lms-product",
            path: "product/:product_code",
            loader: async ({ request, params }) => {
                const product_code = params.product_code;
                const url = new URL(request.url);
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "8");
                url.searchParams.set("domain", "learning");
                url.searchParams.set("is_active", "1");
                try {
                    return handle_success((await LMSDataService.client.url(`/training/crm/products/${product_code}/`).get().json()) as LMSProduct);
                } catch (error) {
                    return handle_error(error);
                }
            },
            children: [
                {
                    path: ":id/seats",
                    loader: async ({ params }) => {
                        const id = params.id;
                        try {
                            return handle_success((await DataService.client.url(`/content/product_sessions/${id}/seats`).get().json()) as ProductSessionSeatsType);
                        } catch (error) {
                            return handle_error(error);
                        }
                    }
                }
            ]
        }
    ]
};
export default LMSRoute;
